
import Hero from '@/components/blog/Hero'
import CategoriesSearchBarComponent from '@/components/blog/CategoriesSearchBar'
import CategorizedBlogPostsComponent from '~/components/blog/CategorizedBlogPosts'
import GetYourGuideBottom from '~/components/shared/GetYourGuideBottom'
export default {
  name: 'BlogPage',
  components: {
    GetYourGuideBottom,
    CategorizedBlogPostsComponent,
    CategoriesSearchBarComponent,
    Hero,
  },
  layout: 'noheader',
  async asyncData({ $config, $axios, params, payload }) {
    const categories = $config.categories
    const categoriesWithPosts = await Promise.all(
      categories.map(async (category) => {
        const posts = await $axios.$get(
          `https://api.plantssogood.com/wp-json/wp/v2/posts?per_page=3&status=publish&page=1&categories=${category.id}&acf_format=standard`
        )
        return {
          ...category,
          posts,
        }
      })
    )
    return {
      categories: categoriesWithPosts,
    }
  },
  head() {
    const title = `The Blog | ${this.$config.siteTitle}`
    const description =
      'The Plants So Good blog is your place for plant-based nutrition articles, cooking tips, and healthy recipes to support your plant-based lifestyle.'
    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/blog/blog-og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/blog/blog-og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1200',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '630',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return `${this.$config.baseURL}${this.$route.fullPath}`
    },
  },
}
